// FieldNotes.js
// This will contain the FieldNotes Class for the sampling events page, each employee attached to a SamplingEvent will have their own FieldsNotes they can set up
import { v4 as uuidv4 } from "uuid";

export class EmployeeFieldNotes {
  constructor(data = {}) {
    this.id = data.id || uuidv4();
    this.samplingEventId = data.sampling_event_id || "";
    this.employeeId = data.employee_id || "";
    this.employeeName = data.employee_name || "";
    this.fieldNote = data.field_note || "";
    this.fieldNoteTime = data.field_note_time || "";
    this.noteOrder = data.note_order || 0;
    this.noteDate = data.note_date || null;
    this.createdAt = data.created_at || null;
    this.updatedAt = data.updated_at || null;
  }

  setFieldNote(fieldNote) {
    if (!fieldNote) {
      this.fieldNote = "";
      return;
    }
    this.fieldNote = fieldNote;
  }

  setFieldNoteTime(fieldNoteTime) {
    if (!fieldNoteTime) {
      this.fieldNoteTime = "";
      return;
    }
    this.fieldNoteTime = fieldNoteTime;
  }

  setNoteOrder(noteOrder) {
    if (!noteOrder) {
      this.noteOrder = null;
      return;
    }
    this.noteOrder = noteOrder;
  }

  setEmployeeId(employeeId) {
    if (!employeeId) {
      this.employeeId = "";
      return;
    }
    this.employeeId = employeeId;
  }

  setEmployeeName(employeeName) {
    if (!employeeName) {
      this.employeeName = "";
      return;
    }
    this.employeeName = employeeName;
  }

  setNoteDate(noteDate) {
    if (!noteDate) {
      this.noteDate = null;
      return;
    }
    // Formatting the incoming date if it is a date type
    if (noteDate instanceof Date) {
      const formattedDate = noteDate.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
      this.noteDate = formattedDate;
    } else {
      this.noteDate = noteDate;
    }
  }

  // Helper function to turn fields that camelcase to snakecase
  setSnakeCaseField(field) {
    return field.replace(/([A-Z])/g, "_$1").toLowerCase();
  }

  toPatch(action, patchData) {
    const patch = {
      patch_type: "sampling_event_field_notes",
      action: action,
      id: this.id,
      sampling_event_id: this.samplingEventId,
    };
    patchData.forEach((field) => {
      const snakeCaseField = this.setSnakeCaseField(field);
      if (snakeCaseField) {
        patch[snakeCaseField] = this[field];
      }
    });
    return patch;
  }

  toJson() {
    return {
      id: this.id,
      sampling_event_id: this.samplingEventId,
      employee_id: this.employeeId,
      employee_name: this.employeeName,
      field_note: this.fieldNote,
      field_note_time: this.fieldNoteTime,
      note_order: this.noteOrder,
      note_date: this.noteDate,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
    };
  }
}
